import { gql } from 'apollo-angular';
import { paginationFragment } from '@services/queries/fragments/lighthouse.fragments';
import {
  shipmentProfileFragment,
  shipmentTableFragment,
} from '@services/queries/fragments/shipments.fragments';

export const shipmentsQuery = gql`
  query Shipments(
    $page: Int
    $size: Int!
    $trashed: Trashed
    $where: QueryShipmentsWhereWhereConditions
    $hasTeam: QueryShipmentsHasTeamWhereHasConditions
    $orderBy: [QueryShipmentsOrderByOrderByClause!]
    $createdBy: QueryShipmentsCreatedByWhereHasConditions
    $updatedBy: QueryShipmentsUpdatedByWhereHasConditions
    $deletedBy: QueryShipmentsDeletedByWhereHasConditions
  ) {
    shipments(
      page: $page
      first: $size
      trashed: $trashed
      hasTeam: $hasTeam
      orderBy: $orderBy
      createdBy: $createdBy
      updatedBy: $updatedBy
      deletedBy: $deletedBy
      where: $where
    ) {
      data {
        ...ShipmentTable
      }
      paginatorInfo {
        ...PaginationFragment
      }
    }
  }
  ${shipmentTableFragment}
  ${paginationFragment}
`;

export const shipmentQuery = gql`
  query Shipment($id: Int!) {
    shipment(id: $id) {
      ...ShipmentProfile
    }
  }
  ${shipmentProfileFragment}
`;

export const ltlTrackingUrlQuery = gql`
  query LtlTrackingUrl($id: Int!) {
    ltlTracking(id: $id) {
      id
      trackingUrl
    }
  }
`;

export const importShipmentDocumentsMutation = gql`
  mutation ImportShipmentDocuments($attachments: [UploadFile!]!) {
    importShipmentDocuments(attachments: $attachments)
  }
`;

export const deleteShipmentsMutation = gql`
  mutation DeleteShipments($ids: [Int!]!, $input: ShipmentDeleteInput!) {
    deleteShipments(ids: $ids, input: $input) {
      id
      deletedAt
    }
  }
`;

export const restoreShipmentsMutation = gql`
  mutation RestoreShipments($ids: [Int!]!) {
    restoreShipments(ids: $ids) {
      id
      deletedAt
    }
  }
`;
